import { css, type Theme } from "@emotion/react";

export const bannerImage = css`
  width: 100%;
  object-fit: contain;
  display: block;
  margin: 0 auto;
  height: calc(100vh - 18rem);
  min-height: 100%;
`;

export const centeredContentContainer = css`
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100%;
  min-height: calc(100vh - 18rem);
`;

export const fullBleedRow = css`
  display: flex;
  align-items: stretch;
  height: 100%;
  min-height: 100vh;
`;

export const panelColumn = css`
  flex: 0 0 41.2%;
  max-width: 41.2%;
`;

export const panelPlaceholder = css`
  width: 100%;
  height: 100%;
`;

export const formColumn = (theme: Theme) => css`
  position: relative;
  display: flex;
  flex: 1;
  flex-direction: column;
  padding: ${theme.ds5.spacing.gap.large};
`;

export const formColumnInner = css`
  position: relative;
  display: flex;
  flex: 1;
  flex-direction: column;
  width: 100%;
  max-width: 880px;
  margin: 0 auto;
`;

export const countrySelectRow = (theme: Theme) => css`
  position: absolute;
  top: 0;
  right: 0;
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: ${theme.ds5.spacing.gap.small};
`;

export const logoContainer = css`
  display: flex;
  justify-content: center;
  padding: 32px 0;
`;

export const logo = css`
  width: 190px;
  height: auto;
`;

export const formContent = css`
  display: flex;
  flex: 1;
  flex-direction: column;
  justify-content: center;
  align-items: center;
`;

export const formGroup = css`
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
`;
